module.exports = __webpack_public_path__ + "img/japan-ischemic-heart-disease-male.3725351c.png";